import { Component, Inject } from '@angular/core';
import { L10nTranslationModule, L10N_LOCALE, L10nLocale } from 'angular-l10n';

@Component({
  selector: 'supplierDB-registration-imprint',
  standalone: true,
  imports: [L10nTranslationModule],
  templateUrl: './imprint.component.html',
})
export class ImprintComponent {
  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale) {}
}
